<template>
  <div>
    <div v-if="preview">
      <div class="bank-account bank-account--preview">
        <div class="bank-account__icon">
          <img :src="account.bankInfo.bankIconUrl" />
        </div>
        <div class="bank-account__bank-title bank-account__bank-title--summary">
          {{ account.bankInfo.bankDisplayName }}
        </div>
        <div>
          {{ account.bankInfo.bankAccountDisplayName }}
        </div>
      </div>
    </div>
    <div v-else :class="classModifiers" @click="$emit('select')">
      <div class="bank-account__icon">
        <img :src="account.bankInfo.bankIconUrl" />
      </div>
      <div class="bank-account__bank">
        <div class="bank-account__bank-title">
          {{ account.bankInfo.bankDisplayName }}
        </div>
        <div class="bank-account__bank-account">
          {{ account.bankInfo.bankAccountDisplayName }}
        </div>
      </div>
      <div
        v-if="removable"
        @click.stop="$emit('remove', account)"
        class="bank-account__remove-wrapper"
      >
        <div class="bank-account__remove"></div>
      </div>
      <div v-if="showStatusMessage" class="bank-account__message">
        {{ account.accountStatusMessage }}
      </div>
    </div>
  </div>
</template>

<script src="./bank-account.js"></script>
<style src="./bank-account.scss" lang="scss"></style>
